var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeObra({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78271 8.60635C1.78271 5.03165 4.68058 2.13379 8.25527 2.13379C11.83 2.13379 14.7278 5.03165 14.7278 8.60635V10.008H1.78271V8.60635Z",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.5,
    width: 15.6,
    height: 3,
    rx: 1.5,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 5.53834V3.00286C10.2917 1.95264 9.44036 1.10126 8.39013 1.10126C7.3399 1.10126 6.48853 1.95264 6.48853 3.00287V5.53834C6.48853 6.58857 7.3399 7.43995 8.39013 7.43995C9.44036 7.43995 10.2917 6.58857 10.2917 5.53834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2168 7.33869V2C10.2168 1.44772 9.76907 1 9.21679 1H7.41357C6.86129 1 6.41357 1.44772 6.41357 2V7.33869",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61816 4.5L3.61816 6.80286",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8857 4.54279L12.8857 6.81674",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeObra);
export default __webpack_public_path__ + "static/media/type_obra.2787ddcd5a60e887df60e8b476484129.svg";
export { ForwardRef as ReactComponent };